import {DI_TOKENS} from '@/di/di.tokens';

import {NavigateFunction} from 'react-router';
import {NavigateOptions} from 'react-router/lib/hooks';

import {injected} from 'brandi';

import {HTMLElementId} from '@/constants';
import {ClientRoutes, GlobalWindow} from '@/types';

export class NavigationService {
  private navigate: NavigateFunction | VoidFunction = () => {};
  private initialized = false;

  constructor(
    private readonly routes: ClientRoutes,
    private readonly globalWindow: GlobalWindow,
  ) {}

  public setNavigate = (navigate: NavigateFunction): void => {
    if (this.initialized) return;

    this.navigate = navigate;
    this.initialized = true;
  };

  public navigateToMainPage(options?: NavigateOptions): void {
    this.navigateTo(this.routes.Main, options);
  }

  public pageReload = (): void => {
    // параметр 0 служит для перезагрузки страницы
    // берет из истории последний добавленный элемент
    this.navigate(0);
  };

  public navigateTo(link: string, options?: NavigateOptions): void {
    this.navigate(link, options);
  }

  public navigateToMainPageStatistic(options?: NavigateOptions): void {
    this.navigateTo(`${this.routes.Main}${this.getCurrentQueryParams()}#${HTMLElementId.Statistic}`, options);
  }

  public navigateToMainPageItems(options?: NavigateOptions): void {
    this.navigateTo(`${this.routes.Main}${this.getCurrentQueryParams()}#${HTMLElementId.Items}`, options);
  }

  public navigateToMainPageItemsTitle(options?: NavigateOptions): void {
    this.navigateTo(`${this.routes.Main}${this.getCurrentQueryParams()}#${HTMLElementId.ItemsTitle}`, options);
  }

  public getCurrentQueryParams(): string {
    return this.globalWindow.location.search;
  }

  public openLink(link: string): void {
    if (link.startsWith('tcsgames')) {
      this.globalWindow.open(link);
    } else if (link.startsWith('http')) {
      // Иначе это диплинк открываем как обычную внешнюю ссылку
      this.externalNavigate(link);
    } else {
      this.navigateTo(link);
    }
  }

  public externalNavigate(link: string): void {
    this.globalWindow.open(link, '_blank', 'noopener noreferrer');
  }
}

injected(NavigationService, DI_TOKENS.clientRoutes, DI_TOKENS.globalWindow);
